import { customDateFormatWithTime, statusFormatterWithMap, textFormatter } from "components/Common/formatter";
import { STATUS_COLOR_MAP } from "pages/warehouse/customerCards/variables";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import convertIcon from "assets/images/svg/convert-card.svg";
import React from "react";

export const customerCardsListColumns = onConvert => [
  {
    title: "Card ID",
    dataIndex: "cardNumber",
    render: (cellContent, asset) => textFormatter(asset?.cardAttributes?.number),
  },
  {
    title: "Barcode",
    dataIndex: "barcode",
    render: textFormatter,
  },
  {
    title: "Depot",
    dataIndex: "depot",
    render: textFormatter,
  },
  {
    title: "State",
    dataIndex: "state",
    render: textFormatter,
  },
  {
    title: "Type",
    dataIndex: "type",
    render: value => statusFormatterWithMap(value, STATUS_COLOR_MAP),
  },
  {
    title: "Custodian",
    dataIndex: "custodian",
    render: (cellContent, asset) =>
      textFormatter(!!asset.custodian ? `${asset.custodianType}/${asset.custodian}` : undefined),
  },
  {
    title: "Creation Date",
    dataIndex: "createdAt",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },
  {
    title: "",
    key: "action",
    render: (_, card) => (
      <ButtonGroup
        disabled={!["Available", "Retired"].includes(card.state)}
        tooltipTitle="Convert"
        icon={convertIcon}
        handleClick={() => onConvert(card)}
      />
    ),
  },
];
